const translation = {
  tags: {
    finance: 'Maliye',
    utilities: 'Yardımcı program',
    design: 'Tasarım',
    image: 'Resim',
    videos: 'Video',
    other: 'Diğer',
    education: 'Eğitim',
    medical: 'Tıbbi',
    social: 'Sosyal',
    agent: 'Aracı',
    business: 'İş',
    weather: 'Hava',
    travel: 'Seyahat',
    productivity: 'Verimli -lik',
    news: 'Haberler',
    entertainment: 'Eğlence',
    search: 'Aramak',
  },
  allTags: 'Tüm Etiketler',
  searchTags: 'Arama Etiketleri',
}

export default translation
